import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSettipos_instrumentos", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var tipos_instrumentos = {
    data: [],
    meta: {},
  };

  await services.tipos_instrumentos.get_all(search).then((res) => {
    tipos_instrumentos = res.data;
  });
  return tipos_instrumentos;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.tipos_instrumentos.show({ id: id }).then((res) => {
    dispatch("ActionSettipo_instrumento", res.data.tipo_instrumento);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.tipos_instrumentos.store(payload).then((res) => {
    commit(types.SET_tipo_instrumento, res.data.tipo_instrumento);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.tipos_instrumentos
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_tipo_instrumento, res.data.tipo_instrumento);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.tipos_instrumentos.delete({ id: id }).then(() => {
    commit(types.SET_tipo_instrumento, null);
  });
};

export const ActionSettipos_instrumentos = ({ commit }, payload) => {
  commit(types.SET_tipos_instrumentoS, payload);
};

export const ActionSettipo_instrumento = ({ commit }, payload) => {
  commit(types.SET_tipo_instrumento, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewtipo_instrumento = ({ commit }) => {
  let tipo_instrumento = {
    nome: "",
    descricao: "",
  };
  commit(types.SET_tipo_instrumento, tipo_instrumento);
};
